import Vue from 'vue'
import router from './router'
import store from './store'
import { ACCESS_TOKEN, WHITE_PATHS, USER_INFO } from './store/mutation-types'
import { loginAuthUrl } from './api/api'
import { getUrlParms } from './utils/comm'
import { getShareInfo } from '@/utils/wxConfig'

function handleVConsole (res) {
  let vsConsoleDom = document.getElementById('__vconsole')
  let dialogWxConsoleDom = document.getElementById('dialog-wx')
  if (res.user_info.subscribe_alert) {
    dialogWxConsoleDom.style.display = 'block'
  } else {
    dialogWxConsoleDom.style.display = 'none'
  }
  if (res.user_info.debug) {
    vsConsoleDom.style.display = 'block'
  } else {
    vsConsoleDom.style.display = 'none'
  }
}

router.beforeEach((to, from, next) => {
  if (WHITE_PATHS.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next()
  } else {
    let redirectURLCODE = getUrlParms('code')
    if (redirectURLCODE) {
      let params = {
        code: redirectURLCODE
      }
      store.dispatch('Login', params).then(res => {
        console.log(res)
        store.dispatch('GetUsers').then(res => {
          handleVConsole(res)
          next()
        })
      }).catch(err => {
        console.log(err)
        window.location.href = loginAuthUrl + `?to_url=${window.location.href}`
      })
    } else {
      console.log('66666')
      if (Vue.ls.get(ACCESS_TOKEN)) {
        store.dispatch('GetUsers').then(res => {
          handleVConsole(res)
          next()
        })
        next()
      } else {
        window.location.href = loginAuthUrl + `?to_url=${window.location.href}`
      }
    }
  }
})
router.afterEach((to, from) => { //     伸手党福利
  // window.__wxjs_is_wkwebview
  // true 时 为 IOS 设备
  // false时 为 安卓 设备
  if (window.__wxjs_is_wkwebview) { // IOS
    if (window.entryUrl === '' || window.entryUrl === undefined) {
      var url = `${process.env.viewURL}${to.fullPath}`
      window.entryUrl = url // 将后面的参数去除
    }
    getShareInfo(to, 'ios', Vue.ls.get(USER_INFO))
  } else { // 安卓
    setTimeout(function () {
      getShareInfo(to, 'android', Vue.ls.get(USER_INFO))
    }, 500)
  }
})



// WEBPACK FOOTER //
// ./src/permission.js